module.exports = __webpack_public_path__ + "img/1.b501daa2.jpg";